import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight, Home as HomeIcon } from "lucide-react";

export const PageBanner = ({ title, breadcrumbs = [], backgroundImage }) => {
  const defaultBg = "https://images.pexels.com/photos/300949/pexels-photo-300949.jpeg";
  
  return (
    <div
      className="relative h-[400px] flex items-center justify-center bg-cover bg-center bg-fixed overflow-hidden"
      style={{ backgroundImage: `url(${backgroundImage || defaultBg})` }}
      data-testid="page-banner"
    >
      {/* Enhanced gradient overlays */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#2C3E50]/80 via-[#E67E22]/60 to-[#F39C12]/70" />
      <div className="absolute inset-0" style={{
        backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.05'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
      }}></div>
      
      {/* Animated particles effect */}
      <div className="absolute inset-0 opacity-20">
        <div className="absolute top-20 left-20 w-2 h-2 bg-white rounded-full animate-float"></div>
        <div className="absolute top-40 right-32 w-3 h-3 bg-white rounded-full animate-float delay-100"></div>
        <div className="absolute bottom-32 left-40 w-2 h-2 bg-white rounded-full animate-float delay-200"></div>
        <div className="absolute bottom-20 right-20 w-3 h-3 bg-white rounded-full animate-float delay-300"></div>
      </div>

      <div className="relative z-10 text-center text-white max-w-4xl px-4 space-y-6">
        {/* Title with animation */}
        <div className="inline-block px-6 py-2 bg-white/10 backdrop-blur-md rounded-full border border-white/20 mb-4 animate-bounce-in">
          <span className="text-sm font-semibold tracking-widest">WYLDWOODS EXPERIENCE</span>
        </div>
        
        <h1 className="font-serif text-5xl md:text-6xl lg:text-7xl font-bold mb-6 animate-fade-in-up" style={{textShadow: '2px 4px 8px rgba(0,0,0,0.5)'}} data-testid="page-title">
          {title}
        </h1>

        {/* Enhanced breadcrumbs */}
        {breadcrumbs.length > 0 && (
          <nav className="flex items-center justify-center space-x-2 text-sm bg-white/10 backdrop-blur-md px-6 py-3 rounded-full inline-flex animate-fade-in-up delay-200" data-testid="breadcrumbs">
            <Link to="/" className="flex items-center hover:text-[#F39C12] transition-all duration-300 group">
              <div className="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center mr-2 group-hover:bg-white/30 transition-all duration-300">
                <HomeIcon size={16} />
              </div>
              <span className="font-semibold">HOME</span>
            </Link>
            {breadcrumbs.map((crumb, index) => (
              <React.Fragment key={index}>
                <ChevronRight size={18} className="text-white opacity-70" />
                {crumb.path ? (
                  <Link to={crumb.path} className="hover:text-[#F39C12] transition-all duration-300 font-semibold">
                    {crumb.name}
                  </Link>
                ) : (
                  <span className="text-white font-bold drop-shadow-lg">{crumb.name}</span>
                )}
              </React.Fragment>
            ))}
          </nav>
        )}
      </div>
    </div>
  );
};

export default PageBanner;
